import { ReactElement, useCallback, useState } from "react"
import { pushClickFaq } from "../../../../utils/gtm"
import { Wrapper } from "../wrapper/wrapper"
import { FaqProps } from "./faq-props"
import * as S from './faq-style'

export function Faq ({ id, values }: FaqProps): ReactElement {
  const [selectedIndex, setSelectedIndex] = useState<number>()
  const handleSelect = useCallback((index: number, title: string) => {
    // Re-clique numa pergunta já aberta não abre nada, então não é engajamento.
    if (selectedIndex === index) return
    setSelectedIndex(index)
    pushClickFaq(title)
  }, [selectedIndex])
  return <S.Container id={id}>
    <Wrapper>
      <S.Title>Perguntas frequentes</S.Title>
      {values.map((item, index) => <>
        <S.FaqTitle onClick={() => handleSelect(index, item.title)} className={selectedIndex === index ? 'expanded' : ''}>{item.title}</S.FaqTitle>
        <S.FaqDescription className={selectedIndex === index ? 'open' : ''} dangerouslySetInnerHTML={{ __html: item.description }} />
      </>)}
    </Wrapper>
  </S.Container>
}
